module.exports = __webpack_public_path__ + "img/logo_pge.8b08eace.png";